export const CONSULTA_EMENDA_EMPENHOS = 'CONSULTA_EMENDA_EMPENHOS';
export const CONSULTA_EMENDA_EMPENHOS_START = 'CONSULTA_EMENDA_EMPENHOS_START';
export const CONSULTA_EMENDA_EMPENHOS_SUCCESS =
  'CONSULTA_EMENDA_EMPENHOS_SUCCESS';
export const CONSULTA_EMENDA_EMPENHOS_ERROR = 'CONSULTA_EMENDA_EMPENHOS_ERROR';

export const CONSULTA_EMENDA_EMPENHOS_TOTAL = 'CONSULTA_EMENDA_EMPENHOS_TOTAL';
export const CONSULTA_EMENDA_EMPENHOS_TOTAL_START =
  'CONSULTA_EMENDA_EMPENHOS_TOTAL_START';
export const CONSULTA_EMENDA_EMPENHOS_TOTAL_SUCCESS =
  'CONSULTA_EMENDA_EMPENHOS_TOTAL_SUCCESS';
export const CONSULTA_EMENDA_EMPENHOS_TOTAL_ERROR =
  'CONSULTA_EMENDA_EMPENHOS_TOTAL_ERROR';

export const TIPO_TRANSFERENCIA_EMPENHOS = 'TIPO_TRANSFERENCIA_EMPENHOS';
export const TIPO_TRANSFERENCIA_EMPENHOS_START =
  'TIPO_TRANSFERENCIA_EMPENHOS_START';
export const TIPO_TRANSFERENCIA_EMPENHOS_SUCCESS =
  'TIPO_TRANSFERENCIA_EMPENHOS_SUCCESS';
export const TIPO_TRANSFERENCIA_EMPENHOS_ERROR =
  'TIPO_TRANSFERENCIA_EMPENHOS_ERROR';

export const RESET_CONSULTA_EMENDA_EMPENHOS = 'RESET_CONSULTA_EMENDA_EMPENHOS';
